import React from 'react';
import { FormattedMessage } from 'react-intl';

import AlertMessage from '@components/individualPortal/dashboard/AlertMsgs/AlertMessage';
import AddressFields from './AddressFields';
import { ADDRESS_TYPE } from '../constants/voterRegistrationConstants';

function ResidentialAddressSection() {
    return (
        <>
            <FormattedMessage id="voterRegistration.form.residentialAddress.header" tagName="h2" />
            <AlertMessage
                type={'info'}
                content={<FormattedMessage id="voterRegistration.form.residentialAddress.alert" />}
                showIcon={true}
                icon={'info-circle'}
            />
            <div id="residentialAddress-section">
                <AddressFields addressType={ADDRESS_TYPE.RESIDENTIAL} />
            </div>
        </>
    );
}

export default ResidentialAddressSection;
